import request from "root/js/request";

export const getItemAdvertAnalyticsCrossMP = async ({
  cabinet_id,
  cabinet_id__in,
  marketplace,
  by,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/cross-mp/dynamic/advert_analytics/",
    method: "get",
    params: {
      cabinet_id,
      cabinet_id__in,
      marketplace,
      ...rest,
    },
  });
  return response.data;
};
